import React, { useEffect } from 'react';

const CustomJSBlock = ({ customJS }) => {
  useEffect(() => {
    if (customJS) {
      const script = document.createElement('script');
      script.innerHTML = customJS;
      document.body.appendChild(script);

      // Cleanup script when component unmounts
      return () => {
        document.body.removeChild(script);
      };
    }
  }, [customJS]);

  return null; // This component doesn't render anything visible
};

export default CustomJSBlock;
